module.exports = __webpack_public_path__ + "static/image4@2x-af6846b2a8c6f3d55bc654ff46556bb8.png";